import PageWithSidebar from '@/src/Common/components/PageWithSidebar';
import { Settings, Link2 } from 'lucide-react';
import { Tabs, TabsContent } from '@radix-ui/react-tabs';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import PicTime from './PicTime';
import { Button } from '@/src/shadComponents/ui/button';

export default function OrgSettings() {
    const navigate = useNavigate();
    let splitPath = window.location.href.split('#');
    let selectedTab = splitPath.length > 1 ? splitPath[1] : 'details';

    const actions = (
        <>
            <Button
                onClick={() => navigate(`/org/edit`)}
            >
                Edit Details
            </Button>
        </>
    );

    return (
        <PageWithSidebar
            title="Smilebooth"
            subtitle={'Organization'}
            actions={actions}
            breadcrumbs={[{ label: 'Organization' }]}
            navigation={[
                {
                    name: 'Details',
                    href: '#details',
                    current: selectedTab === 'details',
                    icon: Settings,
                },
                {
                    name: 'Integrations',
                    href: '#integrations',
                    current: selectedTab === 'integrations',
                    icon: Link2,
                },
            ]}
        >
            <Tabs value={`${selectedTab}`}>
                <TabsContent value="details">
                    <div className="space-y-16 xl:space-y-20">
                        <h1 className="text-2xl font-bold tracking-tight text-foreground">Details</h1>
                        <p className="text-sm leading-6 text-muted-foreground">Organization details</p>
                    </div>
                </TabsContent>
                <TabsContent value="integrations">
                    <div className="row space-y-8 xl:space-y-20">
                        <h2 className="text-lg font-semibold tracking-tight text-foreground px-8">
                            Integrations
                        </h2>
                        <PicTime />
                    </div>
                </TabsContent>
            </Tabs>
        </PageWithSidebar>
    );
}
